import { STM } from '../context/types';

export const tr_trStatements : STM[]  = [
  {
    "id":1,
    "valueKey": "samen1",
    "title":"birlikte çalışma sıklıkladır",
    "title_360_leadership": "ekip çalışmasını teşvik eder",
    "title_360_workenv": "birlikte çalışmak sıklıkla görülür",
    "preferredType": "leadership"
  },
  {
    "id":2,
    "valueKey": "samen2",
    "title":"ekip çıkarları bireysel çıkarlardan önce gelir",
    "title_360_leadership": "ekiplerin başarısını kendi başarısının önüne koyar",
    "title_360_workenv": "takım çıkarları bireysel çıkarları önce gelir",
    "preferredType": "workenv"
  },
  {
    "id":3,
    "valueKey": "samen3",
    "title":"herkes ekip için elinden gelenin en iyisini yapar",
    "title_360_leadership": "ekip için elinden geleni yapar",
    "title_360_workenv": "takım için en iyi çalışılır",
    "preferredType": "leadership"
  },
  {
    "id":4,
    "valueKey": "conf1",
    "title":"anlaşmazlığa yol açabilecekse kişisel bir düşünce paylaşılmaz",
    "title_360_leadership": "bir çatışmaya yol açacaksa görüşünü ifade etmez",
    "title_360_workenv": "kişisel bir görüş paylaşılırken, bu conflict oluşturuyorsa, paylaşılır",
    "preferredType": "workenv"
  },
  {
    "id":5,
    "valueKey": "conf2",
    "title":"huzuru korumak için her çaba sarf edilir",
    "title_360_leadership": "anlaşmazlıkları önlemek için her şeyi yapıyor",
    "title_360_workenv": "barışın korunması için her türlü çaba gösterilir",
    "preferredType": "leadership"
  },
  {
    "id":6,
    "valueKey": "conf3",
    "title":"mevcut kurallara ve standartlara tam olarak uyulur",
    "title_360_leadership": "kurallara ve normlara saygı göstermemizi sağlar",
    "title_360_workenv": "mevcut kurallar ve standartlar precisely uygulanır",
    "preferredType": "workenv"
  },
  {
    "id":7,
    "valueKey": "erken1",
    "title":"çalışanlara iş arkadaşları ve yöneticiler tarafından saygı gösterilir",
    "title_360_leadership": "yöneticim birbirimize saygı duyduğumuz bir ortamı garanti ediyor",
    "title_360_workenv": "iş arkadaşları ve yöneticiler tarafından insanlar saygı görmektedir",
    "preferredType": "workenv"
  },
  {
    "id":8,
    "valueKey": "erken2",
    "title":"sıkı çalışma için takdir gösterilir",
    "title_360_leadership": "yaptıklarımız için takdir ediyor",
    "title_360_workenv": "zor çalışmaya göre tanınır",
    "preferredType": "workenv"
  },
  {
    "id":9,
    "valueKey": "erken3",
    "title":"bağlılığa değer verilir ve takdir gösterilir",
    "title_360_leadership": "harcanan çabaya değer veriyor",
    "title_360_workenv": "bağlılık değer ve takdir edilir",
    "preferredType": "leadership"
  },
  {
    "id":10,
    "valueKey": "zorg1",
    "title":"herkes başkalarına adil davranır",
    "title_360_leadership": "nazik ve saygılıdır",
    "title_360_workenv": "diğerlerine karşı daima doğru davranılır",
    "preferredType": "leadership"
  },
  {
    "id":11,
    "valueKey": "zorg2",
    "title":"herkes başkalarının refahına katkıda bulunur",
    "title_360_leadership": "herkesin kendini iyi hissettiği bir ortamı tercih eder",
    "title_360_workenv": "diğerlerinin refahına katkıda bulunur",
    "preferredType": "workenv"
  },
  {
    "id":12,
    "valueKey": "zorg3",
    "title":"çalışanlar birbirlerine yardım eder",
    "title_360_leadership": "karşılıklı destek ortamını destekliyor",
    "title_360_workenv": "insanlar birbirlerine yardımcı olurlar",
    "preferredType": "leadership"
  },
  {
    "id":13,
    "valueKey": "gelijk1",
    "title":"herkese eşit davranılır",
    "title_360_leadership": "herkese adil davranır",
    "title_360_workenv": "herkes eşit olarak tedavi edilir",
    "preferredType": "workenv"
  },
  {
    "id":14,
    "valueKey": "gelijk2",
    "title":"yaş, köken veya cinsiyet önemli değildir",
    "title_360_leadership": "yaş, köken veya cinsiyete göre ayrım yapmaz",
    "title_360_workenv": "yaş, köken veya cinsiyet önemli değildir",
    "preferredType": "workenv"
  },
  {
    "id":15,
    "valueKey": "gelijk3",
    "title":"herkes karakterlerine göre değil, yaptıklarına göre yargılanır",
    "title_360_leadership": "bi̇zi̇ karakteri̇mi̇ze göre deği̇l, eylemleri̇mi̇ze göre değerlendi̇ri̇r",
    "title_360_workenv": "eylemler, karakter yerine değerlendirilir",
    "preferredType": "leadership"
  },
  {
    "id":16,
    "valueKey": "zelfsturing1",
    "title":"çoğu zaman kendi başına hareket etmek mümkündür",
    "title_360_leadership": "kendi başıma hareket etmeme izin veriyor",
    "title_360_workenv": "çoğu zaman, kendi başına hareket edilebilir",
    "preferredType": "workenv"
  },
  {
    "id":17,
    "valueKey": "zelfsturing2",
    "title":"herkes kendi çalışma yöntemini belirleyebilir",
    "title_360_leadership": "kendi çalışma şeklimi belirlememe izin veriyor",
    "title_360_workenv": "kendi çalışma yöntemini belirlemek mümkündür",
    "preferredType": "leadership"
  },
  {
    "id":18,
    "valueKey": "zelfsturing3",
    "title":"herkes kendi işini nasıl yapacağını planlayabilir",
    "title_360_leadership": "kendi programımı belirlememe izin veriyor",
    "title_360_workenv": "kendi çalışma planını belirlemek mümkündür",
    "preferredType": "workenv"
  },
  {
    "id":19,
    "valueKey": "macht1",
    "title":"Başkalarının davranışını etkileyebilirim",
    "title_360_leadership": "işimi etkiliyor",
    "preferredType": "leadership"
  },
  {
    "id":20,
    "valueKey": "macht2",
    "title":"Yapılacak şeylere karar veren benim",
    "title_360_leadership": "ne yapılması gerektiğini söylüyor",
    "preferredType": "leadership"
  },
  {
    "id":21,
    "valueKey": "macht3",
    "title":"Ne olacağını ben belirlerim",
    "title_360_leadership": "ne yapılması gerektiğini belirler",
    "preferredType": "disabled"
  },
  {
    "id":22,
    "valueKey": "voorspelbaar1",
    "title":"yapı ve düzen vardır",
    "title_360_leadership": "yapı ve düzenliliği garanti eder",
    "title_360_workenv": "düzenli ve düzenli bir yapı vardır",
    "preferredType": "workenv"
  },
  {
    "id":23,
    "valueKey": "voorspelbaar2",
    "title":"işler genellikle planlandığı gibi yürür",
    "title_360_leadership": "işlerin genellikle planlandığı gibi ilerlemesini sağlar",
    "title_360_workenv": "genellikle planlanan gibi şeyler olur",
    "preferredType": "leadership"
  },
  {
    "id":24,
    "valueKey": "voorspelbaar3",
    "title":"geleneksel değerler ve düşünme yöntemleri korunabilir",
    "title_360_leadership": "geleneksel değerlere ve düşüncelere saygıyı garanti eder",
    "title_360_workenv": "geleneksel değerler ve düşünüş yöntemleri korunabilir",
    "preferredType": "workenv"
  },
  {
    "id":25,
    "valueKey": "prestatie1",
    "title":"herkesin elinden gelenin en iyisini yapması mümkündür",
    "title_360_leadership": "elimizden gelenin en iyisini yapmamız için bizi teşvik ediyor",
    "title_360_workenv": "en iyi çalışmaya çalışılır",
    "preferredType": "leadership"
  },
  {
    "id":26,
    "valueKey": "prestatie2",
    "title":"herkes kendi tam potansiyelini gösterebilir",
    "title_360_leadership": "neler yapabileceğimizi göstermemiz için bizi teşvik ediyor",
    "title_360_workenv": "tam potansiyelini göstermek mümkündür",
    "preferredType": "workenv"
  },
  {
    "id":27,
    "valueKey": "prestatie3",
    "title":"herkes işinde mükemmelleşebilir",
    "title_360_leadership": "yaptığımız işte mükemmelleşmemiz için bizi teşvik eder",
    "title_360_workenv": "işinde excel etmek mümkündür",
    "preferredType": "workenv"
  },
  {
    "id":28,
    "valueKey": "zelfontplooi1",
    "title":"herkes sürekli yeni şeyler öğrenebilir",
    "title_360_leadership": "sürekli öğrenmeyi teşvik ediyor",
    "title_360_workenv": "sürekli yeni şeyler öğrenilebilir",
    "preferredType": "workenv"
  },
  {
    "id":29,
    "valueKey": "zelfontplooi2",
    "title":"herkes bilgilerini derinleştirebilir",
    "title_360_leadership": "becerilerimizi derinleştirmemiz için bizi teşvik ediyor",
    "title_360_workenv": "derinlemesine bilgi sahibi olunabilir",
    "preferredType": "leadership"
  },
  {
    "id":30,
    "valueKey": "zelfontplooi3",
    "title":"herkes kişisel gelişimini sürekli olarak genişletebilir",
    "title_360_leadership": "diğerlerinin gelişmesine yardımcı olur",
    "title_360_workenv": " sürekli kişisel gelişimini genişletmek mümkündür",
    "preferredType": "workenv"
  },
  {
    "id":31,
    "valueKey": "duurzaam1",
    "title":"iyi kaliteli işler teslim edilir",
    "title_360_leadership": "ekibin kaliteli iş çıkarmasını sağlar",
    "title_360_workenv": "kaliteli iş sunulur",
    "preferredType": "leadership"
  },
  {
    "id":32,
    "valueKey": "duurzaam2",
    "title":"müşterilere ve/veya işteki diğer kişilere saygı gösterilir",
    "title_360_leadership": "ekibi müşterilere ve diğer ilişkilere saygı göstermeye teşvik eder",
    "title_360_workenv": "müşteriler ve/veya iş ortakları saygı görmektedir",
    "preferredType": "workenv"
  },
  {
    "id":33,
    "valueKey": "duurzaam3",
    "title":"herkes çalışanlar, emniyet ve çevreye önem verir",
    "title_360_leadership": "birey, güvenlik ve çevreyi dikkate almamızı sağlar",
    "title_360_workenv": "güvenlik ve çevreye saygı gösterilir",
    "preferredType": "workenv"
  },
  {
    "id":34,
    "valueKey": "integriteit1",
    "title":"herkes yaptıkları için sorumluluk alır",
    "title_360_leadership": "eylemlerimiz için sorumluluk almamızı sağlar",
    "title_360_workenv": "eylemlerine sorumluluk alınır",
    "preferredType": "workenv"
  },
  {
    "id":35,
    "valueKey": "integriteit2",
    "title":"insanlar dürüsttür",
    "title_360_leadership": "dürüsttür",
    "title_360_workenv": "insanlar dürüsttür",
    "preferredType": "workenv"
  },
  {
    "id":36,
    "valueKey": "integriteit3",
    "title":"gizliliğe saygı gösterilir",
    "title_360_leadership": "kişisel ve gizli bilgileri özenle ele alır",
    "title_360_workenv": "gizlilik saygı görmektedir",
    "preferredType": "leadership"
  },
  {
    "id":37,
    "valueKey": "innovatie1",
    "title":"yeni şeyler denenebilir",
    "title_360_leadership": "bizi yeni çalışma yöntemleri denemeye teşvik eder",
    "title_360_workenv": "yeni şeyler denenebilir",
    "preferredType": "leadership"
  },
  {
    "id":38,
    "valueKey": "innovatie2",
    "title":"herkes birçok yeni deneyim yaşayabilir",
    "title_360_leadership": "bizi yeni deneyimler kazanmaya teşvik ediyor",
    "title_360_workenv": "yeni deneyimler çok fazladır",
    "preferredType": "workenv"
  },
  {
    "id":39,
    "valueKey": "innovatie3",
    "title":"zorlayıcı görevler aranabilir",
    "title_360_leadership": "bizi yeni zorluklar aramaya teşvik ediyor",
    "title_360_workenv": "challenges aranabilir",
    "preferredType": "leadership"
  },
  {
    "id":40,
    "valueKey": "daadkracht1",
    "title":"herkes görevleri ele almak için inisiyatif alır",
    "title_360_leadership": "bizi görevlerde inisiyatif almaya teşvik eder",
    "title_360_workenv": "görevleri tamamlamak için her türlü çaba gösterilir",
    "preferredType": "workenv"
  },
  {
    "id":41,
    "valueKey": "daadkracht2",
    "title":"sonuçları elde etmek için mümkün olan her şeyi yapmaya yüksek öncelik verilir",
    "title_360_leadership": "sonuçların elde edilmesini sağlar",
    "title_360_workenv": "sonuçlar için her türlü çaba gösterilir",
    "preferredType": "leadership"
  },
  {
    "id":42,
    "valueKey": "daadkracht3",
    "title":"belirlenen hedefleri başarmak için mümkün olan her çaba gösterilir",
    "title_360_leadership": "hedeflenen amaçlara ulaşmak için her şeyi yapar",
    "title_360_workenv": "hedeflenen objektiveler için her türlü çaba gösterilir",
    "preferredType": "leadership"
  }
]

export const extra360Tr_TrStatements : Omit<STM, 'title'>[] = [
    // Additional statements used in Actual360 but not IdealClassic
    {
      id: 43,
      valueKey: 'daadkracht4',
      title_360_leadership:
          'kararlar alır',
      preferredType: 'leadership',
    },
    {
      id: 44,
      valueKey: 'gelijk4',
      title_360_leadership:
          'takım üyeleri arasındaki farklılıklara saygı duyar ve değer verir',
      preferredType: 'leadership',
    },
    {
      id: 45,
      valueKey: 'prestatie4',
      title_360_leadership:
          'yapıcı geri bildirim verir',
      preferredType: 'leadership',
    },
]
